// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"2eea1bd9","404":"f4afc3f5","498":"657ecd28"}[chunkId] + ".chunk.js";
};